module.exports = __webpack_public_path__ + "static/img/h-head.61e22811.png";